export const CUSTOM_ICON_BUTTON_VARIANT = {
  default: 'default',
  silver: 'silver',
  outlined: 'outlined',
  primary: 'primary',
} as const;
export type CustomIconButtonVariant =
  (typeof CUSTOM_ICON_BUTTON_VARIANT)[keyof typeof CUSTOM_ICON_BUTTON_VARIANT];

export const CUSTOM_ICON_BUTTON_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;
export type CustomIconButtonSize =
  (typeof CUSTOM_ICON_BUTTON_SIZE)[keyof typeof CUSTOM_ICON_BUTTON_SIZE];

export const getFontSize = (size?: CustomIconButtonSize): number => {
  switch (size) {
    case CUSTOM_ICON_BUTTON_SIZE.large:
      return 24;

    case CUSTOM_ICON_BUTTON_SIZE.medium:
    case CUSTOM_ICON_BUTTON_SIZE.small:
    default:
      return 16;
  }
};
